import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'core-backup',
  version: '0.1.0',
  kind: 'core',
  coreVersion: '^0.1.0',
  name: { vi: 'Sao lưu', en: 'Backups' },
  description: {
    vi: 'Theo dõi sao lưu cơ sở dữ liệu và file, diễn tập khôi phục hằng tháng, cảnh báo khi sao lưu lỗi.',
    en: 'Monitors database and file backups and the monthly restore drill; alerts when a backup fails.',
  },
  dependsOn: ['core-system', 'core-identity', 'core-access', 'core-notification'],
  database: { schema: 'core_backup' },
  permissions: [
    {
      key: 'core-backup.status.view',
      name: { vi: 'Xem tình trạng sao lưu', en: 'View backup status' },
      description: { vi: 'Nhận cảnh báo khi sao lưu lỗi và kết quả diễn tập khôi phục.' },
    },
  ],
  navigation: [
    {
      id: 'admin.backups',
      parent: 'admin',
      label: { vi: 'Sao lưu', en: 'Backups' },
      icon: 'database-backup',
      path: '/admin/backups',
      permission: 'core-backup.status.view',
      order: 25,
    },
  ],
  widgets: [
    {
      key: 'core-backup.status',
      title: { vi: 'Sao lưu', en: 'Backups' },
      permission: 'core-backup.status.view',
      order: 900,
    },
  ],
  notifications: [
    {
      key: 'core-backup.failed',
      name: { vi: 'Sao lưu lỗi', en: 'Backup failed' },
      description: { vi: 'Một lần sao lưu thất bại hoặc quá lâu chưa có bản sao lưu mới.' },
      defaultChannels: ['in_app', 'email'],
      mandatory: true,
    },
    {
      key: 'core-backup.drill',
      name: { vi: 'Kết quả diễn tập khôi phục', en: 'Restore drill result' },
      description: { vi: 'Hằng tháng: khôi phục thử bản sao lưu và kiểm tra số liệu.' },
      defaultChannels: ['in_app', 'email'],
    },
  ],
});
